$(document).ready(function() {
  if( $('#js-form-pro').is('*')) {
    function is_checked(selector, field) {
      if ($(selector).is(':checked')) {
        $(field).removeClass('hide');
        $(field).find('input').prop('disabled', false);
        $(field).find('select').prop('disabled', false);
      } else {
        $(field).addClass('hide');
        $(field).find('input').prop('disabled', true);
        $(field).find('select').prop('disabled', true);
      }
    }

    is_checked('#user_company_attributes_is_using_vat_number', '.user_company_vat_number');
    
    $('#user_company_attributes_is_using_vat_number').change(function() {
      is_checked(this, '.user_company_vat_number');
    });
  }

});